import { useNavigate } from 'react-router-dom';
import { MOOD_API_SERVICE_LINK } from '../../../../../../constants/apiUrl';
import styles from '../../Style/FeaturesModal.module.scss';

export function ApiAccessSection() {
  const navigate = useNavigate();

  return (
    <>
      <h2>API Access</h2>
      <p>
        The MOOD API facilitates download of time series data without going through the website
        interface.
      </p>
      <ul>
        <li>
          <div className={styles.spanLink} onClick={() => navigate('/api')}>
            {MOOD_API_SERVICE_LINK}
          </div>
        </li>
      </ul>
    </>
  );
}
